import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { LineChart } from "@mui/x-charts/LineChart";
import apiUrl from "../config";
import allTeams from "../data/teams"; // Adjust the import path as necessary
import StackBars from "../component/game/ChartBarPoints";
import StackBarsTimePlusMinus from "../component/game/ChartBartimePlusMinus";
import StackBarsAction from "../component/game/ChartBarActions";
import GoalieAction from "../component/game/ChartBarGoalie";
import AdBanner from "../component/ads/AdBanner";

export default function Player() {
  const [chartData, setChartData] = useState({
    assist: [],
    goal: [],
    plusMinus: [],
    toi: [],
  }); // State for chart data
  const [chartDataGoaler, setChartDataGoaler] = useState({
    goalsAgains: [],
    savePctg: [],
    shotsAgainst: [],
    toi: [],
  }); // State for chart data

  const [type, setType] = useState<number>(2);
  const [season, setSeason] = useState("20252026");
  const teams = allTeams || [];
  // const location = useLocation();
  const [player, setPlayer] = useState(null);
  const [colorsTeam, setColorsTeam] = useState(null);
  const [team, setTeam] = useState(null);
  const { playerId } = useParams();
  const [stats, setStats] = useState([]);
  const [totalGoals, setTotalGoal] = useState<number>(0);
  const [totalPowerPlayGoals, setTotalPowerPlayGoals] = useState<number>(0);
  const [totalPowerPlayPoints, setTotalPowerPlayPoints] = useState<number>(0);
  const [totalAssists, setTotalAssists] = useState<number>(0);
  const [playerData, setPlayerData] = useState(null);
  //  const [totalAssists, setTotalAssists] = useState<number>(0);

  const fetchPlayer = async (playerID) => {
    try {
      const response = await axios.get(`${apiUrl}/api/player/${playerID}`);
      const playerData = response.data;
      setPlayer(playerData);
      console.log("playerData", playerData);
      const teamData = teams.find((t) => t.id === playerData.currentTeamId);
      setTeam(teamData);

      if (teamData) {
        setColorsTeam(teamData.colors);
      }
    } catch (error) {
      console.error("Error fetching player data:", error);
    }
  };

  useEffect(() => {
    if (playerId) {
      fetchPlayer(playerId);
    }
  }, [playerId]);

  const fetchPlayerStats = async (typeGame) => {
    try {
      // Fetch players stats
      const playerStatsResponse = await axios.get(
        `${apiUrl}/api/playerStats/${playerId}/${season}/2`,
      );
      const playerStats = playerStatsResponse.data.gameLog; // Assume stats.games is an array of game stats
      console.log("playerStats", playerStats);
      //
      const TeamResponse = await axios.get(
        `${apiUrl}/api/team/stats/${team.triCode}/${season}`,
      );
      const teamSchedule = TeamResponse.data.games; // Assume stats.games is an array of game stats
      const filteredTeamSchedule = teamSchedule.filter(
        (game) =>
          game.gameType === 2 &&
          (game.gameState === "FINAL" || game.gameState === "OFF"),
      );

      console.log("teamSchedule", teamSchedule);

      const mergedStats = filteredTeamSchedule.map((game) => {
        const playerGame = playerStats.find(
          (pg) => pg.gameId === game.id && game.gameType === 2,
        );
        if (playerGame) {
          return { ...game, ...playerGame }; // Merge game data with player stats
        } else {
          return { ...game, didNotPlay: true }; // Add placeholder for games the player didn’t play
        }
      });
      mergedStats.sort(
        (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
      );

      console.log("Merged stats:", mergedStats);
      setPlayerData(mergedStats);
      const toiData = [];

      // Calculate cumulative totals
      if (player?.position === "G") {
        const goalsAgainstData = [];
        const savePctgData = [];
        const shotsAgainstData = [];
        let cumulativegoalsAgainst = 0;
        let cumulativeshutouts = 0;
        let cumulativeshotsAgainst = 0;

        mergedStats.forEach((game, index) => {
          if (!game.didNotPlay) {
            cumulativegoalsAgainst += game.goalsAgainst;
            cumulativeshotsAgainst += game.shotsAgainst;

            const [minutes, seconds] = game.toi.split(":").map(Number);
            const toiInMinutes = minutes + seconds / 60;

            goalsAgainstData.push({ x: index + 1, y: game.goalsAgainst });
            savePctgData.push({ x: index + 1, y: game.savePctg });
            shotsAgainstData.push({ x: index + 1, y: game.shotsAgainst });
            toiData.push({ x: index + 1, y: toiInMinutes });
          }
          if (game.didNotPlay) {
            cumulativegoalsAgainst += 0;
            cumulativeshotsAgainst += 0;

            // const [minutes, seconds] = game.toi.split(':').map(Number);
            // const toiInMinutes = minutes + seconds / 60;

            goalsAgainstData.push({ x: index + 1, y: 0 });
            savePctgData.push({ x: index + 1, y: 0 });
            shotsAgainstData.push({ x: index + 1, y: 0 });
            toiData.push({ x: index + 1, y: 0 });
          }
        });

        setChartDataGoaler((prevData) => ({
          ...prevData,
          goalsAgains: goalsAgainstData,
          savePctg: savePctgData,
          shotsAgainst: shotsAgainstData,
          toi: toiData,
        }));
        console.log("ChartDataGoaler");
      } else {
        const assistData = [];
        const goalData = [];
        const plusMinusData = [];
        const powerPlayGoalsData = [];
        const powerPlayPointsData = [];
        let cumulativeAssist = 0;
        let cumulativeGoal = 0;
        let cumulativePlusMinus = 0;
        let cumulativepowerPlayPoints = 0;
        let cumulativepowerPlayGoals = 0;

        mergedStats.forEach((game, index) => {
          if (!game.didNotPlay) {
            cumulativeAssist += game.assists;
            cumulativepowerPlayPoints += game.powerPlayPoints;
            cumulativeGoal += game.goals;
            cumulativepowerPlayGoals += game.powerPlayGoals;
            cumulativePlusMinus += game.plusMinus;

            const [minutes, seconds] = game.toi.split(":").map(Number);
            const toiInMinutes = minutes + seconds / 60;

            assistData.push({ x: index + 1, y: cumulativeAssist });
            goalData.push({ x: index + 1, y: cumulativeGoal });
            plusMinusData.push({ x: index + 1, y: cumulativePlusMinus });
            toiData.push({ x: index + 1, y: toiInMinutes });
            powerPlayGoalsData.push({
              x: index + 1,
              y: cumulativepowerPlayGoals,
            });
            powerPlayPointsData.push({
              x: index + 1,
              y: cumulativepowerPlayPoints,
            });
          }

          if (game.didNotPlay) {
            cumulativeAssist += 0;
            cumulativepowerPlayPoints += 0;
            cumulativeGoal += 0;
            cumulativepowerPlayGoals += 0;
            cumulativePlusMinus += 0;

            //const [minutes, seconds] = game.toi.split(':').map(Number);
            //const toiInMinutes = minutes + seconds / 60;

            assistData.push({ x: index + 1, y: cumulativeAssist });
            goalData.push({ x: index + 1, y: cumulativeGoal });
            plusMinusData.push({ x: index + 1, y: cumulativePlusMinus });
            toiData.push({ x: index + 1, y: 0 });
            powerPlayGoalsData.push({
              x: index + 1,
              y: cumulativepowerPlayGoals,
            });
            powerPlayPointsData.push({
              x: index + 1,
              y: cumulativepowerPlayPoints,
            });
          }
        });

        setChartData((prevData) => ({
          ...prevData,
          assist: assistData,
          goal: goalData,
          plusMinus: plusMinusData,
          toi: toiData,
          powerPlayGoals: powerPlayGoalsData,
          powerPlayPoints: powerPlayPointsData,
        }));

        setTotalGoal(cumulativeGoal);
        setTotalAssists(cumulativeAssist);
        setTotalPowerPlayGoals(cumulativepowerPlayGoals);
        setTotalPowerPlayPoints(cumulativepowerPlayPoints);
      }
    } catch (error) {
      console.error("Error fetching player stats:", error);
    }
  };

  useEffect(() => {
    fetchPlayerStats(type);
  }, [playerId, season, type, player]);

  const calculateAverageTOI = (chartData) => {
    const toiArray = chartData.toi; // Extract TOI array

    // Calculate total TOI in seconds
    const totalTOI = toiArray.reduce((acc, curr) => acc + curr.y, 0);

    // Calculate average TOI in seconds
    const averageTOI = totalTOI / toiArray.length;

    const minutes = Math.trunc(averageTOI);
    // Extract fractional part and convert to seconds
    const fractionalPart = averageTOI - minutes; // Get the value after the decimal
    const seconds = Math.round(fractionalPart * 60); // Convert fractional part to seconds

    // Format the TOI as MM:SS
    const formattedTOI = `${minutes}:${seconds.toString().padStart(2, "0")}`;

    return formattedTOI;
  };

  const averageTOI = calculateAverageTOI(chartData);

  const calculatePlayerAge = (birthDate) => {
    const birth = new Date(birthDate); // Parse birthDate into a Date object
    const today = new Date(); // Get the current date

    let age = today.getFullYear() - birth.getFullYear(); // Calculate the difference in years

    // Adjust age if the player's birthday hasn't occurred yet this year
    const hasBirthdayPassed =
      today.getMonth() > birth.getMonth() ||
      (today.getMonth() === birth.getMonth() &&
        today.getDate() >= birth.getDate());
    if (!hasBirthdayPassed) {
      age -= 1;
    }

    return age;
  };

  const getPositionLabel = (positionCode) => {
    const positionLabels = {
      C: "Center",
      L: "Left Wing",
      R: "Right Wing",
      D: "Defenseman",
      G: "Goalie",
      // Add more cases as needed
    };

    return positionLabels[positionCode] || "Unknown Position";
  };

  const convertInchesToFeetAndInches = (heightInInches) => {
    const feet = Math.floor(heightInInches / 12); // Calculate the number of feet
    const inches = heightInInches % 12; // Calculate the remaining inches
    return `${feet} ft ${inches} in`;
  };

  useEffect(() => {
    const playerAge = calculatePlayerAge(player?.birthDate);
  }, [player]);

  console.log("team", team);

  const labelSeason = (season) => {
    const year = season.slice(0, 4);
    const nextYear = parseInt(year) + 1;
    return `${year}-${nextYear}`;
  };

  const labelSeasonFormatted = labelSeason(season);

  const changeType = (newType) => () => {
    setType(newType);
    fetchPlayerStats(newType);
  };

  const lastSeason =
    Array.isArray(player?.seasonTotals) && player?.seasonTotals?.length > 0
      ? player?.seasonTotals?.at(-1) // Modern approach
      : null;

  console.log("lastSeason", lastSeason);

  return (
    <div className="wrapper">
      <div
        className="main playerPage"
        style={{
          backgroundImage: `linear-gradient(0deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0) 55%, rgba(255, 255, 255, 0) 90%, rgb(255, 255, 255) 100%), url(https://assets.nhle.com/mugs/actionshots/1296x729/${playerId}.jpg)`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="wrapperStats">
          <div className="playerBoxName">
            <div>
              <div
                className="playerHead"
                style={{
                  background: colorsTeam
                    ? `linear-gradient(${colorsTeam[2]}, ${colorsTeam[0]})`
                    : "gray", // Fallback color if colorsTeam is null
                  border: colorsTeam
                    ? `5px solid ${colorsTeam[0]}`
                    : "5px solid gray",
                  borderRadius: `100px`,
                }}
              >
                <img src={player?.headshot} />
              </div>
            </div>
            <div>
              <h1>
                {player?.firstName.default} {player?.lastName.default}
              </h1>{" "}
              <h2>
                #{player?.sweaterNumber} {getPositionLabel(player?.position)}{" "}
                <Link to={`/team/${team?.rawTricode}`}>
                  <img
                    width={40}
                    src={`https://assets.nhle.com/logos/nhl/svg/${team?.triCode}_dark.svg`}
                    alt={`${team?.fullName} logo`}
                  />
                </Link>
              </h2>
            </div>
            <div className="cardStats">
              <div>
                <p>
                  Age: <b>{calculatePlayerAge(player?.birthDate)}</b>
                </p>
                <p>
                  shoot: <b>{player?.shootsCatches}</b>
                </p>
                <p>
                  weight: <b>{player?.weightInPounds} Lbs</b>
                </p>
                <p>
                  height:{" "}
                  <b>{convertInchesToFeetAndInches(player?.heightInInches)}</b>
                </p>
              </div>
              {player?.position !== "G" ? (
                <>
                  <div>
                    <p>
                      Goals: <b>{totalGoals}</b>
                    </p>
                    <p>
                      Assists: <b>{totalAssists}</b>
                    </p>
                    <p>
                      Points: <b>{totalGoals + totalAssists}</b>
                    </p>
                    <p>
                      ToI: <b>{averageTOI}</b>
                    </p>
                  </div>
                  <div>
                    <p>
                      PPG: <b>{totalPowerPlayGoals}</b>
                    </p>
                    <p>
                      % PPG:{" "}
                      <b>
                        {((totalPowerPlayGoals / totalGoals) * 100).toFixed(2)}
                      </b>
                    </p>
                    <p>
                      PPP: <b>{totalPowerPlayPoints}</b>
                    </p>
                    <p>
                      % PPP:{" "}
                      <b>
                        {(
                          (totalPowerPlayPoints / (totalAssists + totalGoals)) *
                          100
                        ).toFixed(2)}
                      </b>
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <p>
                      Sv%: <b>{lastSeason.savePctg.toFixed(3)}</b>
                    </p>
                    <p>
                      GAA: <b>{lastSeason.goalsAgainstAvg.toFixed(2)}</b>
                    </p>
                    <p>
                      Shutouts: <b>{lastSeason.shutouts}</b>
                    </p>
                    <p>
                      Wins:{" "}
                      <b>
                        {lastSeason.wins}/{lastSeason.gamesStarted}
                      </b>
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>

          <div></div>

          <div>
            <button
              className={type == 2 ? "btn-selected" : "btn"}
              onClick={changeType(2)}
            >
              season stats
            </button>
            <button
              className={type == 3 ? "btn-selected" : "btn"}
              onClick={changeType(3)}
            >
              Playoff stats
            </button>
          </div>

          <h1 className="darkTitle">
            statistics of {type === 3 ? "playoff" : "season"}{" "}
            {labelSeasonFormatted}:
          </h1>

          {/* { player?.position !== 'G' ? (
<div className="width100">
<LineChart style={{ width: "100%", overflowX: "auto", minHeight: "300px" }}    
xAxis={[{ scaleType: 'linear', data: chartData.assist.map((point) => point.x), tickMinStep: 1 }]}
series={[
{ data: chartData.goal.map((point) => point.y), label: 'Goal', color: '#FFD700' },
{ data: chartData.assist.map((point) => point.y), label: 'Assist', color: '#C0C0C0' },
{ data: chartData.plusMinus.map((point) => point.y), label: 'PlusMinus', color: '#B87333' },
{ data: chartData.toi.map((point) => point.y), label: 'Time on Ice', color: 'black' },
]}
/></div>
) : (
<div className="width100">
<LineChart style={{ width: "100%", overflowX: "auto", minHeight: "300px" }}
xAxis={[{ scaleType: 'linear', data: chartDataGoaler?.goalsAgains?.map((point) => point.x), tickMinStep: 1 }]}
series={[
{ data: chartDataGoaler.goalsAgains.map((point) => point.y), label: 'goals Agains', color: 'blue' },
{ data: chartDataGoaler.savePctg.map((point) => point.y), label: 'savePctg', color: 'green' },
{ data: chartDataGoaler.shotsAgainst.map((point) => point.y), label: 'shots Against', color: 'red' },
{ data: chartDataGoaler.toi.map((point) => point.y), label: 'toi', color: 'black' },
]}
/>
</div>
)
} */}

          {player?.position !== "G" ? (
            <>
              <div className="width100 playerChart">
                <div>
                  <StackBars chartData={playerData} />
                </div>
                <div>
                  <StackBarsTimePlusMinus chartData={playerData} />
                </div>
              </div>
              {/* <StackBarsAction chartData={playerData} playerId={playerId} /> */}
            </>
          ) : (
            <>
              <GoalieAction chartData={playerData} playerId={playerId} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
